import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'src/store';
import { clearEMRId } from 'src/store/selectedEMR';
import { useTab } from '../hooks/useTab';
import { PopupComponent } from './PopupComponent';

export default function AlertDialog() {
  const { tabVal, move } = useTab();
  const confirmexitvalue: any = useSelector((state: AppState) => state.confirmexitvalue);
  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (confirmexitpopupval.confirmexitpopupval == true && confirmexitvalue.confirmexitvalue == true) {
      setOpen(true);
      localStorage.setItem('popupShowed', 'true');
    } else {
      setOpen(false);
      localStorage.setItem('popupShowed', 'false');
    }
  }, [confirmexitpopupval, tabVal]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleYes = () => {
    setOpen(false);
    move();
    dispatch(clearEMRId());
  };

  return (
    <div>
      <PopupComponent
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Changes you made will not be saved. Would you like to discard them and proceed to next page?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Close
          </Button>
          <Button onClick={handleYes} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
}
